import _ from 'lodash';
import template from './users.html';


export default {
  name: 'usersComponent',
  template,
  controller: UsersController,
  controllerAs: 'UsersCtrl'
};

/* @ngInject */
function UsersController(
  $scope,
  growl,
  appConfig,
  UserInfoService,
  UsersService,
  ModalService,
  GroupsButtonService
) {
  const vm = this;

  const MUST_CREATE_GROUP = 'You must assign a group for this user';
  const MUST_CREATE_PASSWORD = 'You must assign a password for this user';

  /**
   * Variables available to view
   */
  vm.numberOfLists = 0;
  vm.userLists = {};
  vm.userListArray = [];
  vm.groupList = [];
  vm.active = {
    userList: ''
  };
  vm.user = appConfig.user;
  const existingUserKinds = {
    normal: {
      name: 'Normal',
    },
    admin: {
      name: 'Administrator',
    },
    partner: {
      name: 'Partner',
    },
    superAdmin: {
      name: 'Super Administrator'
    }
  };
  vm.availableUserKinds = _.clone(existingUserKinds);
  delete vm.availableUserKinds.superAdmin;
  if (vm.user.kind !== 'superAdmin') {
    delete vm.availableUserKinds.partner;
  }

  /**
   * Functions available to view
   */
  vm.$onInit = init;
  vm.lengthOf = lengthOf;
  vm.setActiveUserList = setActiveUserList;
  vm.addNewUser = addNewUser;
  vm.createUser = createUser;
  vm.editUser = editUser;
  vm.saveUserEdit = saveUserEdit;
  vm.cancelNewOrEditUser = cancelNewOrEditUser;
  vm.clearUsersTwoFactorSettings = clearUsersTwoFactorSettings;
  vm.deleteUser = deleteUser;
  vm.deleteUserModal = deleteUserModal;
  vm.activateUser = activateUser;
  vm.deactivateUser = deactivateUser;
  vm.suspendUser = suspendUser;
  vm.generateRandomPasswordForUser = generateRandomPasswordForUser;
  vm.toggleShowPassword = toggleShowPassword;
  vm.isCurrentUserSuperAdmin = UserInfoService.isCurrentUserSuperAdmin.bind(UserInfoService);
  vm.isCurrentUserAdmin = UserInfoService.isCurrentUserAdmin.bind(UserInfoService);
  vm.getUserListName = getUserListName;
  vm.isCurrentUser = isCurrentUser;

  function init() {
    return UsersService.getAllUserLists()
      .then(({ data }) => {
        let lists;
        if (data) {
          lists = _.reduce(data, (memo, val) => _.assign(memo, { [val.id]: val }), {});
        }

        vm.userLists = lists || {};
        vm.numberOfLists = lengthOf(vm.userLists);
        if (vm.numberOfLists === 1) {
          setActiveUserList(_.values(vm.userLists)[0]);
        }
        _.forEach(vm.userLists, (val) => {
          val.displayName = getUserListName(val);
          vm.userListArray.push(val);
        });
        vm.userListArray = _.sortBy(vm.userListArray, 'displayName');
      })
      .catch((res) => {
        growl.error(res.error, { title: 'Error Getting UserLists:' });
      });
  }

  function lengthOf(object) {
    return _.isObject(object) ? _.size(object) : 0;
  }

  function setActiveUserList(list) {
    $scope.$applyAsync(() => {
      vm.active = { filterSearch: '' };

      // deselected list
      if (!list?.id) {
        vm.fullUserListActive = undefined;
        return;
      }

      vm.active.userList = list.id;
      vm.fullUserListActive = list;
      UsersService.populateAllInfoForUserList(list.id)
        .then((success) => {
          vm.userLists[success.id] = success;
          const rootGroupId = _.get(success, 'org.rootGroup', _.get(success, 'rootGroup.id'));
          const root = _.find(success.groups, { id: rootGroupId });
          const byParents = _.groupBy(success.groups, 'parent');
          vm.groupList = [maketree(root, byParents)];
        })
        .catch((res) => {
          growl.error(res.error, { title: 'Error Selecting UserLists:' });
        });
    });
  }

  function maketree(grp, byParents) {
    const subs = _.get(byParents, grp.id, []);
    grp.subGroups = grp.subGroups || [];
    grp.subGroups.push(...subs);
    _.map(grp.subGroups, sub => maketree(sub, byParents));
    return grp;
  }

  function getSelectedGroupIds() {
    const groups = GroupsButtonService.rebuildSelectedGroups([], true);
    return _.map(groups, 'id');
  }

  function addNewUser() {
    cancelNewOrEditUser();
    vm.active.newUser = {
      groups: [],
      userList: vm.active.userList,
      forceSecondFactor: vm.userLists[vm.active.userList].org?.settings?.twoFactor?.enforce || false
    };
  }

  function editUser(daUser) {
    cancelNewOrEditUser();

    vm.active.editingUser = angular.copy(daUser);
    vm.active.editingUser.groups = [];
    vm.active.editingUser.forceSecondFactor = Boolean(
      vm.userLists[vm.active.userList].org?.settings?.twoFactor?.enforce ||
        vm.active.editingUser.forceSecondFactor
    );
    vm.activeUserKind = existingUserKinds[vm.active.editingUser.kind].name;
    UsersService.getGroupsForUser(daUser.id)
      .then(({ data: groups }) => {
        vm.selectedGroups = groups;
        vm.active.editingUser.groups.push(...groups.map(({ id }) => id));
      })
      .catch((res) => {
        growl.warning(res.error, { title: 'Could not retrieve the user\'s group' });
      });
  }

  function createUser(user) {
    _.assign(user, { org: vm.userLists[vm.active.userList].org.id });
    user.groups = getSelectedGroupIds();
    let error = false;
    if (!user.password) {
      error = true;
      growl.warning(MUST_CREATE_PASSWORD);
    }
    if (!user.groups.length) {
      error = true;
      growl.warning(MUST_CREATE_GROUP);
    }
    if (error) {
      return;
    }
    let growlMessage = growl.info('Creating new user...', { disableCloseButton: true });
    UsersService.createUser(user)
      .then(({ data }) => {
        vm.userLists[data.userList].users[data.id] = data;
        cancelNewOrEditUser();
        growlMessage.destroy();
        growlMessage = growl.success('User created successfully.');
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, { title: 'Error creating user:' });
      });
  }

  function saveUserEdit(user) {
    let error = false;

    user.groups = getSelectedGroupIds();

    if (!user.groups.length) {
      error = true;
      growl.warning(MUST_CREATE_GROUP);
    }
    if (error) {
      return;
    }
    let growlMessage = growl.info('Saving user...', { disableCloseButton: true });
    if (user.groups && !user.groups.length) {
      delete user.groups;
    }
    if (user.hasOwnProperty('password') && !user.password) {
      delete user.password;
    }
    UsersService.saveUser(user)
      .then(({ data }) => {
        vm.userLists[data.userList].users[data.id] = data;
        cancelNewOrEditUser();
        growlMessage.destroy();
        growlMessage = growl.success('User saved successfully.');
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, { title: 'Error saving user:' });
      });
  }

  function cancelNewOrEditUser() {
    vm.active.editingUser = null;
    vm.active.newUser = null;
    vm.active.showPassword = false;
    vm.selectedGroups = [];
  }

  function clearUsersTwoFactorSettings(userId) {
    let growlMessage = growl.info('Clearing two factor settings...', { disableCloseButton: true });
    UsersService.clearUsersTwoFactorSettings(userId)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Two factor settings cleared.');
        vm.active.editingUser.secondFactorEnabled = false;
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, { title: 'Error clearing two factor settings:' });
      });
  }

  function deleteUser(userId) {
    let growlMessage = growl.info('Deleting the user', {
      disableCloseButton: true
    });
    return UsersService
      .deleteUser(userId)
      .then((success) => {
        const deletedUser = success.data;
        if (vm.isCurrentUserSuperAdmin()) {
          vm.userLists[deletedUser.userList].users[deletedUser.id] = deletedUser;
        } else {
          // TODO: Replace with assignment to undefined
          delete vm.userLists[deletedUser.userList].users[deletedUser.id];
        }
        cancelNewOrEditUser();

        growlMessage.destroy();
        growlMessage = growl.success('User deleted successfully');
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, { title: 'Error deleting user:' });
      });
  }


  function deleteUserModal() {
    const userId = vm.active.editingUser.id;
    if (!userId) {
      return growl.warning('User does not have valid ID, cannot delete.');
    }

    return ModalService.confirmationModal({
      modalTitle: 'Delete User',
      optionalWarning: 'This will delete the user. Are you sure you want to continue?',
      onConfirm: () => deleteUser(userId)
    });
  }

  function changeState(user, state, growlMessage) {
    return UsersService.changeState(user.id, state)
      .then(({ data }) => {
        vm.userLists[vm.active.userList].users[data.id] = data;
        cancelNewOrEditUser();
        growlMessage.destroy();
        growlMessage = growl.success('User updated successfully');
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, { title: 'Error updating user state:' });
      });
  }

  function activateUser(user) {
    let growlMessage;
    if (user.id) {
      if (user.state === 'ACTIVE') {
        growlMessage = growl.warning('The user is already active.');
      } else {
        growlMessage = growl.info('Activating user...', { disableCloseButton: true });
        changeState(user, 'ACTIVE', growlMessage);
      }
    } else {
      growlMessage = growl.error('User does not have a valid ID');
    }
  }

  function deactivateUser(user) {
    let growlMessage;
    if (user.id) {
      if (user.state === 'INACTIVE') {
        growlMessage = growl.warning('The user is already inactive.');
      } else {
        growlMessage = growl.info('Inactivating user...', { disableCloseButton: true });
        changeState(user, 'INACTIVE', growlMessage);
      }
    } else {
      growlMessage = growl.warning('User does not have a valid ID.');
    }
  }

  function suspendUser(user) {
    let growlMessage;
    if (user.id) {
      if (user.state === 'SUSPENDED') {
        growlMessage = growl.warning('The user is already suspended');
      } else {
        growlMessage = growl.info('Suspending user...', { disableCloseButton: true });
        changeState(user, 'SUSPENDED', growlMessage);
      }
    } else {
      growlMessage = growl.warning('User does not have a valid ID');
    }
  }

  function generateRandomPasswordForUser(newUserBool, userOrg) {
    UsersService.generateRandomPassword(userOrg)
      .then((data) => {
        if (newUserBool) {
          vm.active.newUser.password = data.body.randomPassword;
          return vm.active.newUser.password;
        }
        vm.active.editingUser.password = data.body.randomPassword;
        return vm.active.editingUser.password;
      })
      .catch((res) => {
        growl.error(res.error, { title: 'Error getting random password' });
      });
  }

  function toggleShowPassword() {
    vm.active.showPassword = !vm.active.showPassword;
  }

  // user lists pre partner readiness user root group, after user name of org
  function getUserListName(userList) {
    return userList?.rootGroup?.name ?? userList?.org?.name;
  }

  function isCurrentUser() {
    return vm.active.editingUser.id === vm.user.id;
  }
}
